import styled, { css } from "styled-components";
import { ComponentProps } from "react";
import { colors } from "src/styles/theme";

export default function FullWidthButton(props: ComponentProps<typeof StyledButton>) {
  return <StyledButton {...props} />;
}

const buttonThemeObj = {
  white: {
    bgc: "#FDFDFD",
    fontColor: "#1A1A1A",
    outLine: "#1A1A1A",
  },
  green: {
    bgc: "#004B49",
    fontColor: "#fff",
    outLine: "#004B49",
  },
  greenReverse: {
    bgc: "#ffffff00",
    fontColor: colors.green.first,
    outLine: colors.green.first,
  },
  lightGreen: {
    bgc: colors.green.second,
    fontColor: "#fff",
    outLine: colors.green.second,
  },
  lightGreen2: {
    bgc: colors.green.third,
    fontColor: "#fff",
    outLine: colors.green.third,
  },
  black: {
    bgc: "#2c2c2c",
    fontColor: "#fff",
    outLine: colors.black.default,
  },
  gray: {
    bgc: colors.gray.first,
    fontColor: "#fff",
    outLine: colors.black.default,
  },
  darkGray: {
    bgc: "#595959",
    fontColor: "#fff",
    outLine: colors.black.default,
  },
  lightGray: {
    bgc: colors.gray.second,
    fontColor: "#000",
    outLine: colors.black.default,
  },
  lightGray2: {
    bgc: colors.gray.fourth,
    fontColor: "#000",
    outLine: colors.black.default,
  },
  lightGray3: {
    bgc: colors.gray.third,
    fontColor: "#000",
    outLine: colors.black.default,
  },
  yellow: {
    bgc: colors.yellow.first,
    fontColor: "#000",
    outLine: "black",
  },
  red: {
    bgc: colors.red.first,
    fontColor: "#fff",
    outLine: colors.black.default,
  },
};

type ButtonStyleType = {
  $outline?: boolean;
  $round?: boolean;
  $activeResizeOff?: boolean;
  $colorTheme?: keyof typeof buttonThemeObj;
  $pointerEventNone?: boolean;
  $transparent?: boolean;
  disabled?: boolean;
};

const StyledButton = styled.button<ButtonStyleType>`
  ${(p) => {
    if (!p.$colorTheme) {
      p.$colorTheme = "green";
    }
    if (!p.$outline) {
      p.$outline = false;
    }

    return css`
      border: ${p.$outline ? `2px solid ${buttonThemeObj[p.$colorTheme].outLine}` : "none"};
      background-color: ${buttonThemeObj[p.$colorTheme].bgc};
      color: ${buttonThemeObj[p.$colorTheme].fontColor};
      padding: 26px 16px;
      font-size: 18px;
      height: 60px;
      width: 100%;
    `;
  }}

  ${(p) => {
    return p.$pointerEventNone
      ? css`
          pointer-events: none;
        `
      : "";
  }}
  ${(p) => {
    return p.$transparent
      ? css`
          opacity: 0.6;
        `
      : "";
  }}

  ${(p) => {
    if (p.$colorTheme == "white") {
      return "";
    }
    if (p.$colorTheme == "greenReverse") {
      return "";
    }
    if (p.$transparent) {
      return "";
    }
    return css`
      box-shadow: inset 0px 0px 10px #00000008;
    `;
  }}

  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.15s;

  &:disabled {
    pointer-events: none;
    filter: opacity(0.7) brightness(0.7);
  }
  &:active {
    filter: brightness(0.75);
    transform: ${(p) => (p.$activeResizeOff ? "scale(1);" : "scale(0.975)")};
  }
`;
